/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SomniaSearchRequest = {
    filterBy?: SomniaSearchRequest.filterBy;
    term: string;
};

export namespace SomniaSearchRequest {

    export enum filterBy {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        PROJECT = 'PROJECT',
        TOKEN = 'TOKEN',
        ALL = 'ALL',
    }


}

